import {call, put} from "redux-saga/effects";
import {getPackageApi, modificationPackageApi,} from "../../../../common/apis/packageApi";
import * as actions from "../state/modificationPackageActions";

export function* modificationPackageSaga({ payload }) {
  try {
    const response = yield call(modificationPackageApi, payload);
    yield put(actions.modificationPackageSuccessAction(response.data.body));
  } catch (error) {
    yield put(actions.modificationPackageFailAction(error));
  }
}

export function* getPackageToModifySaga({ payload }) {
  try {
    const response = yield call(getPackageApi, payload);
    yield put(actions.getPackageToModifySuccessAction(response.data.body));
  } catch (error) {
    yield put(actions.getPackageToModifyFailAction(error));
  }
}
